const PupilActionTypes = {
  FETCH_PUPIL_START: 'FETCH_PUPIL_START',
  FETCH_PUPIL_SUCCESS: 'FETCH_PUPIL_SUCCESS',
  FETCH_PUPIL_ERROR: 'FETCH_PUPIL_ERROR',
};

export default PupilActionTypes;
